var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, CircularProgress } from "@mui/material";
import { useMemo } from "react";
import { UiTypography } from "../ui_typography";
export const UiSpinner = (_a) => {
    var { size, title } = _a, props = __rest(_a, ["size", "title"]);
    return useMemo(() => (_jsxs(Box, { alignItems: "center", display: "flex", flexDirection: "column", justifyContent: "center", children: [_jsx(Box, { display: "flex", alignItems: "center", justifyContent: "center", marginBottom: title ? 2 : undefined, children: _jsx(CircularProgress, Object.assign({ size: size }, props)) }), title && (_jsx(Box, { alignItems: "center", display: "flex", justifyContent: "center", children: _jsx(UiTypography, { children: title }) }))] })), [props, size, title]);
};
//# sourceMappingURL=ui_spinner.js.map